import React from "react";

function BikeDriverIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsAndroid="http://schemas.android.com/apk/res/android"
      width="44"
      height="44"
    >
      <path
        stroke="#00000000"
        d="M0 22a22 22 0 1144 0 22 22 0 11-44 0"
        androidFillType="evenOdd"
      ></path>
      <path
        fill="#DAE8ED"
        stroke="#00000000"
        d="M0 44h44V0H0z"
        androidFillType="evenOdd"
      ></path>
      <path
        fill="#468FBC"
        stroke="#00000000"
        d="M32.439 35.286c-3.44-1.26-7.34-2.367-10.439-2.367-2.373 0-5.216.652-7.961 1.522C8.969 35.694 3.527 37.988 0 41.093V44h44v-2.463c-2.852-2.713-7.182-4.843-11.561-6.25"
        androidFillType="evenOdd"
      ></path>
      <path
        fill="#1A6F99"
        stroke="#00000000"
        d="M16.246 33.759s-2.21.367-2.334 2.996c-.122 2.63 3.153 7.124 7.87 7.124 4.718 0 7.876-3.503 8.555-6.482.68-2.978-3.7-4.045-3.7-4.045l-10.391.407z"
        androidFillType="evenOdd"
      ></path>
      <path
        fill="#F4B28E"
        stroke="#00000000"
        d="M21.842 16.249c-3.13 0-6.516.518-9.225 1.385.044 1.958.147 4.688.392 6.316.04.263.092.532.15.802.122.547.29 1.105.492 1.662.125.348.264.691.418 1.03.428.955 1.209 2.066 2.072 3.009.025.393.041.8.042 1.195 0 .446-.016.876-.065 1.252 0 0-.812 2.455-.849 3.78-.016.479.23 1.292.75 2.156.688 1.139 1.856 2.369 3.549 3.054.57.231 1.198.416 1.889.48 4.948.449 8.951-5.192 7.191-7.444 0 0-.209-.825-.368-2.1a22.144 22.144 0 01-.167-3.038c.627-.777 1.17-1.607 1.503-2.343.15-.34.293-.683.418-1.03a13.404 13.404 0 00.642-2.465c.245-1.628.347-4.358.388-6.316-2.713-.871-6.094-1.385-9.222-1.385"
        androidFillType="evenOdd"
      ></path>
      <path
        fill="#D38A6A"
        stroke="#00000000"
        d="M28.337 27.215c-.135.78-.2 1.56-.221 2.303-.94 3.205-2.242 5.095-6.276 5.985-2.432.537-5.23 2.036-5.82 3.333-.521-.864-.767-1.677-.751-2.156.037-1.325.849-3.78.849-3.78.049-.376.065-.806.065-1.252-.004-1.713-.295-3.657-.295-3.657l12.449-.776z"
        androidFillType="evenOdd"
      ></path>
      <path
        fill="#F4B28E"
        stroke="#00000000"
        d="M31.093 15.304s0 .173-.003.476c0 .233-.004.54-.008.905-.003.285-.01.606-.018.95-2.713-.872-6.094-1.386-9.222-1.386V9.874c1.815-.591 3.542-1.053 4.778-1.17 4.055-.385 4.473 6.6 4.473 6.6M21.842 9.874v6.375c-3.13 0-6.516.517-9.225 1.385-.007-.343-.01-.664-.015-.949-.007-.325-.007-.606-.01-.827-.004-.351-.004-.554-.004-.554s.421-6.985 4.476-6.6c1.233.117 2.963.579 4.778 1.17"
        androidFillType="evenOdd"
      ></path>
      <path
        fill="#2A7F21"
        stroke="#00000000"
        d="M21.842 3C13.395 3 7.83 9.16 7.932 16.316c.098 7.158 2.591 14.136 3.405 14.586.257.144.627.248 1.034.31.87.141 1.9.111 2.336-.029.392-.122.338-1.33.238-2.227-.062-.55-.139-.987-.139-.987l7.036-11.336 7.033 11.336s-.078.436-.14.99v.004c-.095.897-.15 2.098.243 2.22.421.132 1.404.166 2.258.044l.004-.004c.432-.062.829-.165 1.104-.32.813-.451 3.31-7.43 3.41-14.587C35.852 9.16 30.564 3 21.841 3"
        androidFillType="evenOdd"
      ></path>
      <path
        fill="#454C54"
        stroke="#00000000"
        d="M11.69 28.697c.707.532 1.858 1.02 3.329 1.4 0 .554-.078 1.012-.312 1.086-.437.14-1.467.17-2.336.03-.59-.743-1.015-1.965-1.37-3.321.226.358.457.635.688.805M32.586 28.047c-.352 1.3-.77 2.463-1.346 3.177l-.004.003c-.854.122-1.837.088-2.259-.044-.234-.074-.31-.536-.31-1.086 1.465-.38 2.621-.868 3.328-1.4.195-.144.393-.366.59-.65"
        androidFillType="evenOdd"
      ></path>
      <path
        fill="#809B9E"
        stroke="#00000000"
        d="M33.998 17.15s-.004.68-.044 1.693c-.815-.451-1.797-.861-2.89-1.209-2.713-.871-6.094-1.385-9.222-1.385-3.131 0-6.515.518-9.225 1.385-1.122.36-2.127.78-2.952 1.245a61.847 61.847 0 01-.04-1.729c.906-.527 1.918-.949 2.966-1.292 4.335-1.42 9.222-1.42 9.222-1.42h.029c.43.005 5.335.06 9.248 1.342 1.085.355 2.094.802 2.908 1.37"
        androidFillType="evenOdd"
      ></path>
      <path
        fill="#809B9E"
        stroke="#00000000"
        d="M15.019 30.097c-1.47-.38-2.622-.868-3.33-1.4-.23-.17-.462-.447-.69-.805-.245-.924-.458-1.906-.667-2.844-.425-1.895-.594-4.48-.666-6.169.825-.465 1.829-.886 2.95-1.245.045 1.958.147 4.688.394 6.316.04.263.09.532.15.802.12.547.29 1.105.49 1.662.126.347.265.691.419 1.03.216.477.517.994.876 1.511.04.363.074.773.074 1.142M33.953 18.842v.004c-.066 1.685-.234 4.292-.663 6.202-.224.99-.448 2.031-.704 2.999-.198.284-.396.506-.591.65-.707.532-1.862 1.02-3.329 1.4 0-.366.033-.776.07-1.134v-.004c.359-.52.663-1.033.88-1.514.15-.34.293-.683.418-1.03a13.512 13.512 0 00.642-2.464c.245-1.63.348-4.358.388-6.317 1.093.347 2.075.758 2.89 1.208"
        androidFillType="evenOdd"
      ></path>
      <path
        fill="#F7DBCD"
        stroke="#00000000"
        d="M31.06 17.634c0 .122-.005.249-.005.376-.006.255-.017.521-.023.793-.027.953-.07 1.989-.137 2.947-.022.272-.038.543-.06.798a24.505 24.505 0 01-.16 1.402 13.453 13.453 0 01-.643 2.466c-.121.343-.265.686-.419 1.03-.05.11-.104.217-.159.333-.198.376-.44.775-.72 1.18v.005c-.325.465-.693.93-1.078 1.363a12.47 12.47 0 01-.924.937c-.435.393-.87.725-1.27.952-1.212.688-2.433.981-3.62.948-1.193.033-2.414-.26-3.625-.948-.406-.232-.847-.57-1.286-.97a11.791 11.791 0 01-.908-.919 15.537 15.537 0 01-1.079-1.357v-.017a10.08 10.08 0 01-.258-.388 9.155 9.155 0 01-.44-.753 7.882 7.882 0 01-.176-.366 13.726 13.726 0 01-.417-1.03 36.33 36.33 0 01-.149-.422c-.137-.415-.259-.83-.347-1.24-.054-.272-.11-.544-.148-.804a27.323 27.323 0 01-.192-1.795c-.11-1.462-.166-3.175-.198-4.521 2.706-.87 6.094-1.386 9.223-1.386 3.13 0 6.501.516 9.218 1.386M13.74 26.645a16.67 16.67 0 000 0"
        androidFillType="evenOdd"
      ></path>
      <path
        fill="#F7DBCD"
        stroke="#00000000"
        d="M14.07 27.446c.056.122.11.238.176.366-.066-.128-.126-.25-.181-.366-.034-.077-.06-.153-.094-.23.034.077.065.153.1.23M13.652 26.415c.027.077.059.153.088.23-.03-.077-.065-.153-.093-.23-.05-.138-.099-.277-.143-.42l.148.42M14.246 27.812a9.18 9.18 0 000 0M14.686 28.565c.083.133.17.26.259.388v.016c-.088-.138-.176-.271-.259-.404M12.817 22.155c-.022-.284-.04-.578-.058-.876.019.295.036.593.058.876M14.945 28.97c.324.46.693.925 1.078 1.357-.347-.072-.687-.15-1.006-.233 0-.36-.034-.764-.072-1.124M27.655 30.327c.385-.432.754-.898 1.078-1.363-.033.355-.066.765-.066 1.13a15.067 15.067 0 01-1.012.233M31.066 17.634c0 .122-.006.249-.011.376 0-.127.005-.255.005-.376h.006z"
        androidFillType="evenOdd"
      ></path>
      <path
        fill="#6DBA3F"
        stroke="#00000000"
        d="M35.182 17.15c-.15-4.118-5.262-8.462-13.34-8.462-4.037 0-7.337 1.086-9.643 2.685-2.284 1.589-3.6 3.68-3.696 5.722-.004.019-.004.037-.004.056-.01.29-.01.594-.004.905.015.494.048 1.011.103 1.54.32 3.129 1.328 6.619 2.402 8.296-.246-.924-.459-1.906-.668-2.844-.424-1.895-.593-4.48-.667-6.169a61.847 61.847 0 01-.04-1.729c.906-.527 1.918-.949 2.966-1.292 4.335-1.42 9.222-1.42 9.222-1.42h.03c.428.005 5.334.06 9.247 1.342 1.085.355 2.093.802 2.907 1.37 0 0-.003.68-.043 1.693v.003c-.067 1.685-.235 4.292-.664 6.202-.225.99-.448 2.031-.705 3 1.116-1.612 2.174-5.224 2.505-8.452.051-.525.084-1.038.099-1.53.004-.225.004-.442 0-.657 0-.088-.004-.174-.007-.258"
        androidFillType="evenOdd"
      ></path>
      <path
        fill="#FFF"
        stroke="#00000000"
        d="M15.166 10.859s-3.82 3.44-5.367 12.704c0 0 .942 3.125 1.44 3.877 0 0 1.368-11.236 8.126-17.793 0 0-2.592.335-4.198 1.212M22.193 9.414s-3.616 4.94-5.772 10.403c-2.156 5.465-2.657 9.282-2.657 9.282s2.518.874 4.917.998c0 0 1.046-10.089 9.036-19.815 0 0-2.695-1.1-5.524-.868"
        androidFillType="evenOdd"
      ></path>
    </svg>
  );
}

export default BikeDriverIcon;
